export default "__VITE_ASSET__e4ce8d07__"